export const OrderStatus = {
  open: 100,
  pending: 200,
  userActionRequired: 250,
  validated: 300,
  autocomplete: 350,
  autocompletionFailed: 370,
  validationError: 390,
  paymentOpen: 400,
  paymentPending: 450,
  paymentRefused: 499,
  paid: 500,
  inProduction: 600,
  documentsRemoved: 700,
  finished: 900,
  error: 1000,
  partiallyCancelled: 950,
  cancelled: 999,
  getKey
}
// get the enum key by value
function getKey(enumValue) {
  return Object.keys(OrderStatus).find(key => OrderStatus[key] === enumValue)
}
